import React from 'react';

const TranslateIcon = () => (
  <svg width="24" height="24" viewBox="0 0 640 600" fill="none">
    <path
      fill="#4987be"
      d="M382.44,191.68A33.76,33.76,0,0,0,350.69,214L253.88,481.38A22.85,22.85,0,1,0,297,496.58l13-37.79,1.18-3.45H453.3l1.19,3.45,13,37.79A22.85,22.85,0,0,0,489.08,512h.05a22.85,22.85,0,0,0,21.5-30.6L414.2,214a33.76,33.76,0,0,0-31.76-22.31Zm1.71,65.23,3.38,9.68,48.91,140.24,2.36,6.77H325.64l2.36-6.77,48.91-140.24,3.41-9.68A2,2,0,0,1,384.15,256.91Z"
    />
    <path
      fill="#4987be"
      d="M19.38,86.11H290.52l-3.29,7.21a470.85,470.85,0,0,1-87.09,129.33l-3.72,3.92-3.72-3.92a468.65,468.65,0,0,1-59.94-78.21,19.51,19.51,0,0,0-16.63-9.39h-.08a19.43,19.43,0,0,0-16.61,29.52,506.25,506.25,0,0,0,65,84.79l3.72,3.91L164,256.76c-1.92,1.62-3.64,3.06-5.26,4.38L62.61,339.88A19.43,19.43,0,0,0,60,367.3h0a19.43,19.43,0,0,0,27.27,2.64l96.32-78.89c2.89-2.36,6-5,9.5-8l3.36-2.9,3.35,2.9c3.2,2.75,6.4,5.45,9.52,8L236.2,313.1a19.42,19.42,0,1,0,24.61-30.05l-26.75-21.91c-1.45-1.19-2.89-2.41-4.29-3.59l-1-.81-4.12-3.49,3.72-3.91a510,510,0,0,0,103-160l1.29-3.18h40.79a19.38,19.38,0,0,0,19.38-19.38h0a19.38,19.38,0,0,0-19.38-19.38H215.9v-28A19.38,19.38,0,0,0,196.52,0h-.23a19.38,19.38,0,0,0-19.38,19.38v28H19.38A19.38,19.38,0,0,0,0,66.73H0A19.38,19.38,0,0,0,19.38,86.11Z"
    />
  </svg>
);

export default TranslateIcon;
